import React from "react";
import { Isvg } from "../../components";
import { Dispatcher } from "../../flux";
import { Button } from "@vitalsource/vstui";

const closeTOCPanel = () => {
  Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "toc");
};

const Header = ({ drillUp, returnLevel, returnText, title }) => (
  <div className="header noselect">
    {returnLevel && (
      <Button
        id="header-button"
        label={i18n.t("base.back")}
        className="noButton"
        onClick={drillUp}
        naked
      >
        <Isvg src="/img/chevron_left_large.svg" />
      </Button>
    )}
    <h2
      id={returnLevel ? "special-panel-header" : "panel-header-toc"}
      className={
        "panel-title no-highlight " +
        (typeof title === "object" ? "has-content" : "")
      }
      tabIndex={-1}
    >
      {returnText || title}
    </h2>
    <Button
      className="panel-close-button"
      onClick={closeTOCPanel}
      naked
    >
      <span>
        {i18n.t("reader.panels.close-panel", {
          panelName: returnText || title
        })}
      </span>
    </Button>
  </div>
);

export default Header;
